import React, { useEffect, useState, useContext, useRef } from 'react';
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd';
import {IProps, IState} from './types';
import MasterPage from '@components/MasterPage';
import Header from './components/Header';
import Folders from './components/Folders';
import DesignsList from './components/DesignsList';
import DragDesigns from './components/DragDesigns';
import WarningScreen from '@components/WarningScreen';
import MouseTooltip from '@components/MouseTooltip';
import { useSelector, useDispatch } from 'react-redux';
import selectors from '@state/selectors';
import actions from '@state/actions';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { DesignsContext } from '@utils/DOIgnition/DesignsContext';
import * as S from './styles';
import { IElement } from '@routes/private/Editor/types';
import { copyFile } from '@utils/cloudStorage';
import { IDesign } from '@state/designs/types';
const uuid = require('react-uuid');

const MyDesigns:React.FC<IProps> = (props, state: IState) => {

  const authContext = useContext(AuthContext);
  const{ searching, setSearching, searchSelectedOne, searchSelectedAll, 
    searchValue, getQuerySearchByFolder, searchFolder, setSearchFolder,
    allFilters, getFilterQuery, fetchCounter, getQuerySearch, sortByQuery } = useContext(DesignsContext);
  const dispatch = useDispatch();
  const foldersUser = useSelector(selectors.folders.getFolders);
  const folderUserUpdated = useSelector(selectors.folders.getFolder);
  const searches = useSelector(selectors.designs.getDesignSearch);

  const fetchFolders = () => {
    let query = `?filter=c.createdBy.email=%27${authContext?.userData.profile.email}%27`;
    return new Promise((resolve, reject) => {
      dispatch(actions.folders.fetchFolders(query,(result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  }

  const updateFolder = (folder: any) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.folders.updateFolder(folder, (result: any, error: any) => {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      }))
    })
  }

  const fetchDesigns = (option: string, length: number, folderId: string) => {    
    const query = createQuery(option, length, folderId);
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.fetchDesigns(query, (result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  }

  const fetchCounters = () => {
    const userData = {
      email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
      name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
    };
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.fetchDesignCounters(userData.email, false, (result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  }

  const updateDesign = (design: any, action: string) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.updateDesign(design, action, (result: any, error: any) => {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      }))
    })
  }

  const updateDesigns = (designs: any) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.updateDesigns(designs, (result: any, error: any) => {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      }))
    })
  }

  const updateDesignsFields = (updateInfo: any) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.updateDesignsFields(updateInfo, (result: any, error: any) => {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      }))
    })
  }
  
  const createQuery=(option: string, length: number, folderId: string)=>{
    var finalQuery = "";
    const userData = {
      email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
      name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
    };
    
    let user = `c.createdBy.email='${userData.email}'`;
    let status = `and c.designStatus='ACTIVE'`;
    let filters = loadingDesigns===false ? getFilterQuery() : '';
    let search = loadingDesigns===false ? getQuerySearch() : '';
    let orderBy = sortByQuery!=='' ? `orderby=${sortByQuery}` : 'orderby=c.updateDate DESC';

    filters = encodeURIComponent(filters);
    search = encodeURIComponent(search);

    if (option === "all") {
      var finalQuery = `?filter=${user} ${status} ${filters} ${search}&${orderBy}&start=${length - 20}&pagelength=20`;
    } else if (option === "favorite") {
      var finalQuery = `?filter=${user} ${status} and c.favorite=true  ${filters} ${search}&${orderBy}&start=${length - 20}&pagelength=20`;
    } else if (option === "folder") {
      var finalQuery = `?filter=${user} ${status} and c.folder='${folderId}' ${filters} ${search}&${orderBy}&start=${length - 20}&pagelength=20`;
    } else if (option === "names") {
      finalQuery = `?filter=${user} and c.formatName LIKE "%untitled%" ${status}&${orderBy}&start=0&pagelength=20`;
    } else if (option === "all-search") {
      let searchFolder = getQuerySearchByFolder('');
      let searchFormat = encodeURIComponent(searchValue.toLowerCase());
      finalQuery = `?filter=${user} ${status} ${filters} and ${searchFolder}(c.formatName LIKE "%${searchFormat}%" or udf.searchCustomTagsDesign(c.tags.customTags, "${searchFormat}"))&${orderBy}&start=${length - 20}&pagelength=20`;
    }
    
    return finalQuery;
  }

  const [isLoading, setIsLoading] = useState(true);
  const [folders, setFolders] = useState(state.folders);
  const [selectedFolder, setSelectedFolder] = useState("All My Designs");
  const [foldersLength, setFoldersLength] = useState(0);
  const [currentDesigns, setCurrentDesigns] = useState(state.currentDesigns);
  const [globalDesigns, setGlobalDesigns] = useState(state.globalDesigns);
  const [hasMore, setHasmore] = useState(state.hasMore);
  const [indexFolder, setIndexFolder] = useState(0);
  const [indexFolderDelete, setIndexFolderDelete] = useState(-1);
  const [folderDeleteDesigns, setFolderDeleteDesigns] = useState(false);
  const [finishDeleteFolder, setFinishDeleteFolder] = useState(false);
  const [open, setOpen] = useState(false);
  const [warningOptions, setWarningOptions] = useState({
    title: '',
    subtitle: '',
    actionTitle: '',
    actionFunction: () => {},
    closeActionTitle: '',
    errorNote: '',
    errorArguments: [],
  });
  const [selectedDesigns, setSelectedDesigns] = useState([] as any);
  let loadingDesigns = false;

  const handleWarningScreen = (openValue:boolean, title:string, subtitle:string, actionTitle:string, actionFunction:any, closeActionTitle:string, errorNote:string, errorArguments: any) => {
    setOpen(openValue);
    setWarningOptions({
      title: title,
      subtitle: subtitle,
      actionTitle: actionTitle,
      actionFunction: actionFunction,
      closeActionTitle: closeActionTitle,
      errorNote: errorNote,
      errorArguments: errorArguments,
    })
  }

  useEffect(() => {
    const run = async () => {
      var newGlobalDesigns: any[] = Array(2).fill([]);
      var newHasMore: any = Array(2).fill(true);
      const userFolders: {id: string, name: string, counter: number}[] = []; 
      try {
        const counters: any = await fetchCounters();
        const newFolders: any = await fetchFolders();
        const AllDesigns: any = await fetchDesigns("all", 20, "");
        const FavoritesDesigns: any = await fetchDesigns("favorite", 20, "");
        userFolders.push({id: "all", name: "All My Designs", counter: counters[0].counter});
        newGlobalDesigns[0] = AllDesigns;
        if (AllDesigns?.length !== 20) newHasMore[0] = false;
        userFolders.push({id: "favorite", name: "Favorites", counter: counters[1].counter});
        newGlobalDesigns[1] = FavoritesDesigns;
        if (FavoritesDesigns?.length !== 20) newHasMore[1] = false;
        if (newFolders?.length > 0 && newFolders[0].folders?.length > 0) {
          setFoldersLength(newFolders[0].folders.length);
          let foldersOrder = newFolders[0].folders;
          foldersOrder.sort((a:any,b:any)=> (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
          userFolders.push(...foldersOrder);
          newGlobalDesigns = newGlobalDesigns.concat(Array(newFolders[0].folders.length).fill([]));
          newHasMore = newHasMore.concat(Array(newFolders[0].folders.length).fill(true));
        }
        setHasmore(newHasMore);
        setGlobalDesigns(newGlobalDesigns);
        setCurrentDesigns(AllDesigns);
        setFolders(userFolders);
        setIsLoading(false);
      } catch(error) {
        console.error(error);
      }
    }
    run();
  }, [])

  useEffect(() => {

    let userFolders : {id: string, name: string, counter: number}[] = [];
    if (folders) {
      userFolders.push(folders[0]);
      userFolders.push(folders[1]);
    }

    if (folders && folderUserUpdated?.length > 0 && folderUserUpdated[0].folders?.length > 0) {
      if ((folderUserUpdated[0].folders.length+2)===hasMore.length) {
        let newUserFolders : {id: string, name: string, counter: number}[] = [];
        newUserFolders = folderUserUpdated[0].folders.map( (folder:any) => {
          let oldFolder = folders.find((folder:any) => folder.id === folder.id);
          if (oldFolder && (folder.name!==oldFolder.name || folder.counter!==oldFolder.counter)) return folder;
          else return oldFolder;
        });
        userFolders.push(...newUserFolders);
      } else if ((folderUserUpdated[0].folders.length+2)<hasMore.length) {
        let folderDelete = folders[indexFolderDelete];
        userFolders = folders;
        userFolders.splice(indexFolderDelete, 1);
        let newGlobalDesigns = globalDesigns;
        newGlobalDesigns.splice(indexFolderDelete, 1);
        
        newGlobalDesigns = updateGeneralFolders(newGlobalDesigns, userFolders, folderDelete.id);
        setGlobalDesigns(newGlobalDesigns);

        let newHasMore = hasMore;
        newHasMore.splice(indexFolderDelete, 1);
        setHasmore(newHasMore);
        setIndexFolderDelete(-1);
        setFolderDeleteDesigns(false);
        if (indexFolder===0) setCurrentDesigns(newGlobalDesigns[0]);
        else if (indexFolder===1) setCurrentDesigns(newGlobalDesigns[1]);
      } else {
        let newUserFolders = folderUserUpdated[0].folders.slice(0, foldersLength);
        newUserFolders.sort((a:any,b:any)=> (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
        let otherFolders = folderUserUpdated[0].folders.slice(foldersLength);
        userFolders.push(...newUserFolders);
        userFolders.push(...otherFolders);
      }

      if (userFolders.length>hasMore.length && indexFolderDelete===-1) {
        var newHasMore = hasMore;
        newHasMore.push(true);
        setHasmore(newHasMore);
        let newGlobalDesigns = globalDesigns;
        newGlobalDesigns.push([]);
        setGlobalDesigns(newGlobalDesigns);
      }
    }

    if ( folderUserUpdated?.length>0 && folderUserUpdated[0].folders?.length ===0) {
      if (folderDeleteDesigns && folders[indexFolderDelete]) {
        let folderDelete = folders[indexFolderDelete];
        let newGlobalDesigns = updateGeneralFolders([...globalDesigns], userFolders , folderDelete.id);
        setGlobalDesigns(newGlobalDesigns);
        if (indexFolder===0) setCurrentDesigns(newGlobalDesigns[0]);
        else if (indexFolder===1) setCurrentDesigns(newGlobalDesigns[1]);
      }
    }
    setFolders(userFolders);
  }, [folderUserUpdated])


  const updateGeneralFolders = (newGlobalDesigns: any, folders: any, folder: string) => {
    newGlobalDesigns = newGlobalDesigns.map((itemDesigns: any, index: number)=>{
      itemDesigns = itemDesigns.filter((design:any) => {
        if (folderDeleteDesigns) {
          if (design.folder === folder) {
            if (folders[index]) folders[index].counter--;
          } else return design;
        } else {
          if (design.folder === folder) design.folder = "";
          return design;
        }
      });
      return itemDesigns;
    });
    return newGlobalDesigns;
  }

  useEffect(() => {
    if (globalDesigns) {
      setSelectedDesigns([]);
      if (searchSelectedOne) {
        setCurrentDesigns([searchSelectedOne]);

        let folderDesign = folders.find( (item:any) => item.id === searchSelectedOne.folder);
        if (folderDesign!==undefined) setSelectedFolder(folderDesign.name);
        else setSelectedFolder("All My Designs");
      }
      else loadFolderSearchDesigns();
    }
  }, [searchSelectedOne])

  useEffect(() => {
    if (searchSelectedAll && hasMore?.length>0) {
      setSelectedDesigns([]);

      const run = async () => {
        try {
          let newHasMore = hasMore;
          newHasMore[0] = true;
          if (searches.length<20) newHasMore[0] = false;
          setHasmore(newHasMore);
          loadingDesigns = true;
          

          setIsLoading(true);
          let folder = folders.findIndex( (item:any) => item.id === searchFolder);
          if (folder!==-1) {
            setIndexFolder(folder);
            setSelectedFolder(folders[folder].name);
          } else {
            setIndexFolder(0);
            setSelectedFolder("All My Designs");
          }

          const AllDesigns: any = await fetchDesigns("all-search", 20, "");
          fetchCounter('');
          setCurrentDesigns(AllDesigns);
          setIsLoading(false);
        } catch(error) {
          console.error(error);
        }
      }
      run();
    }
    else if (folders) loadFolderSearchDesigns();
  }, [searchSelectedAll])

  useEffect(() => {
    if (searchFolder!=="") {
      loadingDesigns = true;
      loadFolderDesigns(true);
    }
  }, [searchFolder]);

  useEffect(() => {
    if (globalDesigns && !loadingDesigns) {
      loadFolderDesigns(false);
      if (allFilters.length>0 || searchSelectedAll) {
        let folder = folders.find( (item:any) => item.name === selectedFolder);
        if (folder) fetchCounter(folder.id);
        else fetchCounter('');
      }
    } else loadingDesigns = false;
  }, [allFilters]);

  useEffect(() => {
    if (globalDesigns && !loadingDesigns && sortByQuery!=="") loadFolderDesigns(false);
  }, [sortByQuery]);

  const loadFolderDesigns = async(loadGlobalDesigns: boolean) => {
    try {
      setIsLoading(true);
      setSelectedDesigns([]);
      let newDesigns = [] as any;
      
      let folder = folders.findIndex( (item:any) => item.id === searchFolder);
      if (folder===-1) folder = indexFolder;

      if (searchFolder === "all" || folder === 0) newDesigns = await fetchDesigns("all", 20, "");
      else if (searchFolder === "favorite" || folder===1) newDesigns = await fetchDesigns("favorite", 20, "");
      else if (searchFolder !== "") newDesigns = await fetchDesigns("folder", 20, searchFolder);
      else newDesigns = await fetchDesigns("folder", 20, folders[folder].id);
      
      if (folder!==-1) {
        let newHasMore = hasMore;
        newHasMore[folder] = newDesigns.length<20 ? false : true;
        setHasmore(newHasMore);
        setIndexFolder(folder);
        setSelectedFolder(folders[folder].name);
        if (loadGlobalDesigns) {
          let newGlobalDesigns = globalDesigns;
          globalDesigns[folder] = newDesigns;
          setGlobalDesigns(newGlobalDesigns);
        }
      }
      
      setCurrentDesigns(newDesigns);
      setIsLoading(false);
    } catch(error) {
      console.error(error);
    }
  }

  const loadFolderSearchDesigns = () => {
    let newDesigns = [] as any;
    let folder = folders.findIndex( (item:any) => item.id === searchFolder);
    
    if (folder===-1) folder = 0;
    if (globalDesigns && globalDesigns[folder]) {
      newDesigns = globalDesigns[folder];
      setIndexFolder(folder);
      setSelectedFolder(folders[folder].name);
      setCurrentDesigns(newDesigns);
    }
  }

  const selectFolder = (index: number) => {
    if (folders.length > 0) {
      setSelectedFolder(folders[index].name);
      
      if (globalDesigns[index]) {
        setIndexFolder(index);
        setSearchFolder('');
        
        setCurrentDesigns(globalDesigns[index]);
        if (hasMore.length && hasMore[index] === true && globalDesigns[index]?.length === 0) {
          loadMoreDesigns(index, true);
          if (allFilters.length>0) fetchCounter(folders[index].id);
        } 
        if (searching) setSearching(false);
      }
      setSelectedDesigns([]);
    }
  }

  const loadMoreDesigns = async (index: number|undefined, fromFolder?:boolean) => {    
    var validIndex = index ? index : indexFolder;
    var newDesigns: any = [];
    try {

      let lenght = globalDesigns[validIndex].length;
      if (searchSelectedAll || allFilters.length>0 || sortByQuery!=="") lenght=currentDesigns.length;
      if (fromFolder) lenght = 0;

      if (searchSelectedAll && !fromFolder) newDesigns = await fetchDesigns("all-search", lenght + 20, "");
      else if (validIndex === 0) newDesigns = await fetchDesigns("all", lenght + 20, "");
      else if (validIndex === 1) newDesigns = await fetchDesigns("favorite", lenght + 20, "");
      else newDesigns = await fetchDesigns("folder", lenght + 20, folders[validIndex].id);

      if (newDesigns && newDesigns.length > 0) {
        if (!searchSelectedAll && allFilters.length==0 && sortByQuery==="") {
          var newGlobalDesigns: any[] = globalDesigns;
          newGlobalDesigns[validIndex] = [...newGlobalDesigns[validIndex], ...newDesigns];
          setCurrentDesigns(newGlobalDesigns[validIndex]);
          setGlobalDesigns(newGlobalDesigns);
        } else {
          if (!fromFolder) setCurrentDesigns([...currentDesigns, ...newDesigns]);
          else setCurrentDesigns(newDesigns);
        }
      }
      if (newDesigns.length !== 20) {
        setHasmore([
          ...hasMore.slice(0, validIndex),
          false,
          ...hasMore.slice(validIndex + 1)
        ]);
      }
    } catch(error) {
      console.error(error);
    }
  }

  const addDesign = (item: any, index: number) => {
    var newDesigns: any = [];
    var newGlobalDesigns = globalDesigns;
    if (newGlobalDesigns[index] && newGlobalDesigns[index].length < 20) {
      if ((newGlobalDesigns[index].length === 0 && !hasMore[index]) || (newGlobalDesigns[index].length > 0 )) newDesigns = [item, ...newGlobalDesigns[index]];
    } else {
      newDesigns = [item, ...newGlobalDesigns[index].slice(0, 20)];
    }
    newGlobalDesigns[index] = newDesigns;
    setGlobalDesigns(newGlobalDesigns);
    return newDesigns;
  }

  const removeDesign = (item: any, index: number) => {
    var newDesigns: any = globalDesigns[index];
    var newGlobalDesigns = globalDesigns;
    const designIndex = newGlobalDesigns[index].findIndex((design: any) => (design.id === item.id));
    if (designIndex >= 0) {
      newDesigns = [
        ...newGlobalDesigns[index].slice(0, designIndex),
        ...newGlobalDesigns[index].slice(designIndex + 1)
      ]
    }
    newGlobalDesigns[index] = newDesigns;
    setGlobalDesigns(newGlobalDesigns);
    return newDesigns;
  }

  const updateStateDesign = (item: any, index: number) => {
    var newDesigns: any = globalDesigns[index];
    var newGlobalDesigns = globalDesigns;
    const designIndex = newGlobalDesigns[index].findIndex((design: any) => (design.id === item.id));
    if (designIndex >= 0) {
      newDesigns = [
        item,
        ...newGlobalDesigns[index].slice(0, designIndex),
        ...newGlobalDesigns[index].slice(designIndex + 1)
      ]
    }
    newGlobalDesigns[index] = newDesigns;
    setGlobalDesigns(newGlobalDesigns);
    return newDesigns;
  }

  const refreshDesigns = (design: any) => {
      var newFolders = folders;
      var newGlobalDesigns = globalDesigns;
      newGlobalDesigns[0] = addDesign(design, 0);
      newFolders[0].counter += 1;
      if (design.favorite === true) {
        newFolders[1].counter += 1;
        newGlobalDesigns[1] = addDesign(design, 1);
      }
      const indexOfFolder = folders.findIndex((folder: any) => (folder.id === design.folder));
      if (indexOfFolder >= 0) {
        newGlobalDesigns[indexOfFolder] = addDesign(design, indexOfFolder);
        const awaitUpdateFolder = async () => { 
          try {
            var newFoldersUser = foldersUser[0];
            newFolders[indexOfFolder].counter += 1;
            newFoldersUser.folders = newFolders.slice(2);
            const saveFolder: any = await updateFolder(newFoldersUser);
          } catch(error) {
            console.error(error);
          }
        }
        awaitUpdateFolder();
      }
      setCurrentDesigns(newGlobalDesigns[indexFolder]);
      setFolders(newFolders);
  }

  const duplicateDesign = (id: string) => {
    return new Promise((resolve, reject) => {
      const userData = {
        email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
        name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
      };
      dispatch(actions.designs.duplicateDesign({id: id,userData: userData, keepFolder: true}, (result: any, error: any) => {
        if (error) {
          reject(error);
        }
        else {
          resolve(result);
        }
      }))
    })
  }

  const handleDuplicate = async (item: any) => {
    try {
      const designDuplicated:any = await duplicateDesign(item.id);
      refreshDesigns(designDuplicated);
      window.open(`/editor/design/${designDuplicated.id}`);
    } catch (error) {
      handleWarningScreen(
        true, "Create a Copy & Edit",
        `The design was not duplicated, please try later.`,
        "", undefined, "OKAY", "Duplicate design process failure",[]
      );
      console.error(error);
    }
  }

  const handleFavorite = async (item: any) => {
    item.favorite = item.favorite ? false : true;
    try {
      var updatedDesign: any = await updateDesign(item, 'FAVORITES');
      let action = item.favorite ? 'add' : 'delete';
      if (updatedDesign.status === 200 ) {
        var newCurrentDesigns: any = [];
        if (action === "add")  newCurrentDesigns = addDesign(item, 1);
        if (action === "delete")  newCurrentDesigns = removeDesign(item, 1);
        if (indexFolder === 1) setCurrentDesigns(newCurrentDesigns);
        const userFolders = folders;
        if (userFolders[1]) {
          userFolders[1].counter = newCurrentDesigns.length;
          setFolders(userFolders);
        }
        var updatedAllMyDesigns = updateStateDesign(item, 0);
        let newGlobalDesigns = globalDesigns;
        newGlobalDesigns[0] = updatedAllMyDesigns;
        setGlobalDesigns(newGlobalDesigns);
      }
    } catch(error) {
      console.error(error);
    }
  }

  const handleEdit = async (item: any, action: string, folder:number) => {
    var newCurrentDesigns: any = [];
    if (action === "add") {
      newCurrentDesigns = addDesign(item, folder);
      var updatedAllMyDesigns = updateStateDesign(item, 0);
      let newGlobalDesigns = globalDesigns;
      newGlobalDesigns[0] = updatedAllMyDesigns;
      setGlobalDesigns(newGlobalDesigns);
    }
    if (action === "delete") newCurrentDesigns = removeDesign(item, folder);
    if (indexFolder === folder) setCurrentDesigns(newCurrentDesigns);
  }

  const handleAskDelete = (item: any) => {
    handleWarningScreen(
      true, "Delete Design",
      `If you delete this design you will not be able to access it again.`,
      "CANCEL", () => {handleDelete(item)}, "DELETE", "", []
    );
  }

  const handleDelete = async (item: IDesign) => {
    item.designStatus = 'INACTIVE';
    const userData = {
      email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
      name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
    };
    item.updatedBy = userData;
    try {
      handleWarningScreen(
        true, "Delete Design",
        `If you delete this design you will not be able to access it again.`,
        "", () => {return false;}, "DELETING...", "", []
      );
      var updatedDesign: any = await updateDesign(item, 'DELETE');
      if (updatedDesign.status === 200) {
        handleWarningScreen(
          true, "Delete Design",
          `The design was deleted successfully.`,
          "", () => {handleFinishDelete(item)}, "OKAY", "", []
        );
      } else {
        throw new Error;
      }
    } catch(e) {
      handleWarningScreen(
          true, "Delete Design",
          `The design was not deleted, please try later...`,
          "", undefined, "OKAY", "Delete design process failure", []
      );
    }
  }

  const handleMultipleDelete = async (items: IDesign[]) => {
    const userData = {
      email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
      name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
    };
    const designs = items.map(item => {
      return {
        ...item,
        designStatus: 'INACTIVE',
        updatedBy: userData
      }
    })
    try {
      var updatedDesign: any = await updateDesigns(designs);
      handleWarningScreen(
        true, "Delete Designs",
        `The designs were deleted successfully.`,
        "", () => {
          designs.map(design => {handleFinishDelete(design)});
        }, "OKAY", "", []
      );
    } catch(e) {
      handleWarningScreen(
          true, "Delete Designs",
          `The designs were not deleted, please try later...`,
          "", undefined, "OKAY", "Designs bulk delete failure", []
      );
    }
  }

  const handleFinishDelete = async (item: any) => {
    handleWarningScreen(
      false, "", ``, "", undefined, "", "", []
    );
    var newFolders = folders;
    var newGlobalDesigns = globalDesigns;
    const allIndex = newGlobalDesigns[0].findIndex((design: any) => (design.id === item.id));
    if (allIndex >= 0) newGlobalDesigns[0] = removeDesign(item, 0);
    newFolders[0].counter -= 1;
    const favoriteIndex = newGlobalDesigns[1].findIndex((design: any) => (design.id === item.id));
    if (favoriteIndex >= 0) newGlobalDesigns[1] = removeDesign(item, 1);
    if (item.favorite === true) newFolders[1].counter -= 1;
    if (item.folder !== null) {
      const indexOfFolder = folders.findIndex((folder: any) => (folder.id === item.folder));
      if (indexOfFolder >= 0) {
        const indexInFolder = newGlobalDesigns[indexOfFolder].findIndex((design: any) => (design.id === item.id));
        if (indexInFolder >= 0) newGlobalDesigns[indexOfFolder] = removeDesign(item, indexOfFolder);
        newFolders[indexOfFolder].counter -= 1;
        try {
          var newFoldersUser = foldersUser[0];
          newFoldersUser.folders = newFolders.slice(2);
          const saveFolder: any = await updateFolder(newFoldersUser);
        } catch(error) {
          console.error(error);
        }
      }
    }
    setCurrentDesigns(newGlobalDesigns[indexFolder]);
    setFolders(newFolders);
  }

  const handleDeleteFolder = async(idx: number, deleteDesigns:boolean) => {
    if (finishDeleteFolder) setFinishDeleteFolder(false);
    setIndexFolderDelete(idx);
    setFolderDeleteDesigns(deleteDesigns);
    let folderDelete = folders[idx];
    
    try {
      let newFolders = foldersUser[0];
      newFolders.folders = foldersUser[0].folders.filter((item:any) => item.id !== folderDelete.id);
      const saveFolder: any = await updateFolder(newFolders);
    } catch(error) {
      console.error(error);
    }

    try {
      if (globalDesigns[idx].length>0) {
        let designs = globalDesigns[idx].map(design => {
          if (deleteDesigns) {
            design.designStatus = 'INACTIVE';
            const userData = {
              email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
              name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
            };
            design.updatedBy = userData;
          }
          else design.folder = '';
          return design;
        });
        const saveDesigns: any = await updateDesigns(designs);
      } else {
        let updateInfo = {
          "filter": `c.folder='${folderDelete.id}'`,
          "fields":[
              {"field": deleteDesigns ? "designStatus" : "folder", "value" : deleteDesigns ? "INACTIVE" : ""}
          ]
        };
        const saveDesigns: any = await updateDesignsFields(updateInfo);
      }
    } catch(error) {
      console.error(error);
    }

    setFinishDeleteFolder(true);
    props.onFolderActions && props.onFolderActions(folderDelete.name, "DELETE" , "success", idx);
    if (indexFolder===idx) {
      setSelectedFolder("All My Designs");
      setIndexFolder(0);
      setCurrentDesigns(globalDesigns[0]);
    }
  }

  const handleSelectedDesigns = (item:any, idx: number, addDesign:boolean) => {
    if (!addDesign) setSelectedDesigns(selectedDesigns.filter((design:any) => item.id !== design.id));
    else {
      selectedDesigns.indexOf(item) === -1 && setSelectedDesigns([...selectedDesigns, item]);
    }
  }

  const handleSelectedManyDesigns = (items:any) => setSelectedDesigns(items);

  const handleDropDesignsFolder = async(item:any, folderAdd:number) => {
    let prevSelectedDesigns = selectedDesigns;
    if (prevSelectedDesigns.indexOf(item) === -1) {
      setSelectedDesigns([...selectedDesigns, item]);
      prevSelectedDesigns.push(item)
    }
    
    if (prevSelectedDesigns?.length>0 && folderAdd>1) {
      setIsLoading(true);

      let oldFolder = -1;
      prevSelectedDesigns.forEach( (design:any) => {
        oldFolder = folders.findIndex( (item:any) => item.id === design.folder);
      });

      let newFolders = foldersUser[0];
      newFolders.folders = newFolders.folders.map( (folder:any, idx:number) => {
        if ((folderAdd-2)===idx){
          prevSelectedDesigns.forEach((design:any)=> {
            if (design.folder!==folder.id) folder.counter++; 
          });
        } else {
          let countDesigns = prevSelectedDesigns.filter((item:any) => {
            if(item.folder ===folder.id)return item;
          });
          folder.counter = folder.counter - countDesigns.length;
        }
        return folder;
      });

      let foldertoMove = folders[folderAdd];
      let selectedDesignsUpdated = prevSelectedDesigns.map((design:any) => {
        design.folder = foldertoMove.id;
        return design;
      });

      try {
        const saveFolders: any = await updateFolder(newFolders);

        if (saveFolders.status === 200) {
          const saveDesigns: any = await updateDesigns(selectedDesignsUpdated);
        }
        props.onFolderActions && props.onFolderActions(foldertoMove.name, "MOVEDESIGNS" , "success", folderAdd);
      } catch(error) {
        console.error(error);
        props.onFolderActions && props.onFolderActions(foldertoMove.name, "MOVEDESIGNS" , "error", folderAdd);
      }

      var newGlobalDesigns = globalDesigns;
      var newHasMore = hasMore;

      newGlobalDesigns[0] = newGlobalDesigns[0].map((design:any) => {
        let designNew = selectedDesignsUpdated.find( (item:any) => item.id === design.id); 
        if (designNew!==undefined) return designNew;
        else return design;
      });

      newGlobalDesigns[1] = newGlobalDesigns[1].map((design:any) => {
        let designNew = selectedDesignsUpdated.find( (item:any) => item.id === design.id); 
        if (designNew!==undefined) return designNew;
        else return design;
      });

      if (indexFolder>1) {
        newGlobalDesigns[indexFolder] = globalDesigns[indexFolder].filter((design:any) => {
          let designSearch = selectedDesignsUpdated.find( (item:any) => item.id === design.id); 
          if (designSearch===undefined) return design;
        });
      }

      newGlobalDesigns[folderAdd] = [];
      newHasMore[folderAdd] = true;
      if (oldFolder!==-1 && oldFolder!==indexFolder) {
        newGlobalDesigns[oldFolder] = [];
        newHasMore[oldFolder] = true;
      } 

      setCurrentDesigns(newGlobalDesigns[indexFolder]);
      setGlobalDesigns(newGlobalDesigns);
      setHasmore(newHasMore);
      setSelectedDesigns([]);
      if (searching) setSearching(false);
      
      setIsLoading(false);
    }
  }

  const onActions = (item: any, action: string, folder?:number) => {
    if (folder || folder===0) {
      if (action === "DELETEFOLDER") handleDeleteFolder(folder, false);
      else if (action === "DELETEFOLDERDESIGNS") handleDeleteFolder(folder, true);
      else if (action === "ADDDESIGN") handleSelectedDesigns(item, folder, true);
      else if (action === "DELETEDESIGN") handleSelectedDesigns(item, folder, false);
      else if (action === "DROPDESIGNS") handleDropDesignsFolder(item, folder);
      else handleEdit(item, action, folder);
    } else {
      if (action === "DUPLICATEEDIT") handleDuplicate(item);
      if (action === "FAVORITEDESIGN") handleFavorite(item);
      if (action === "DELETE") handleAskDelete(item);
      if (action === "DELETEMULTIPLE") handleMultipleDelete(item);
      if (action === "SELECTEDDESIGNS") handleSelectedManyDesigns(item);
    }
  }
  return ( 
    <S.Root>
      <WarningScreen
        open={open}
        setOpen={setOpen}
        options={warningOptions}
      />
      <MasterPage
        pageIndex={2}
        newHeight={300}
      >
        <S.AbsoluteContentContainer>
          <Header/>
          <DndProvider backend={HTML5Backend}>
            <S.ContentContainer>
              <Folders
                folders={folders}
                selectedFolder={selectedFolder}
                selectFolder={selectFolder}
                hasMore={hasMore}
                onActions={onActions}
                finishDeleteFolder={finishDeleteFolder}
              />
              <DragDesigns counter={selectedDesigns.length}/>
              <DesignsList
                isLoading={isLoading}
                hasNoDesigns={folders?.length && folders[0].counter > 0 ? false : true}
                currentDesigns={currentDesigns}
                hasMore={hasMore?.length > 0 ? hasMore[indexFolder] : false}
                loadMoreDesigns={loadMoreDesigns}
                onActions={onActions}
                selectedFolder={selectedFolder}
                handleWarningScreen={handleWarningScreen}
              />
            </S.ContentContainer>
          </DndProvider>
        </S.AbsoluteContentContainer>
      </MasterPage>
    </S.Root>
  );
}

export default MyDesigns;